module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAMAAACeyVWkAAAAe1BMVEUAAAAre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8sre8v////m7/np8vry9/zu9ftFjNLf6/fU5fW40+6uzeupyeqUvOWFs+FYl9ZUldVQk9RLkNNJjtI0gc72+f2/1++awOaXvuZyp9zEjfsKAAAAEHRSTlMAyyTv/I1P87euMzDljkj0RKp5owAAAKdJREFUGNN1kVkSgjAMQFPasouxgIjiBm73P6F2I3UG3k/TN20mC1gKyUpRMlkAEWXoySIvK44Er6yMBYaI2HxP8J9EJ0npfldnfaQAeSDr/mF0DptZjvUJe6UjCczL/U++2psOGZReqiO+rUQOguTQXtECtoOpq6eh8ZK7vB81HpoLOpir4dkFEqWrd+dBTU69EenSHLbRysyMDl8n8eouaG8c+by3L5RpFqjc8q5HAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_edit.png
// module id = G+XB
// module chunks = 9